export default __webpack_public_path__ + "static/media/termsOfUse.3bfda7db.pdf";